// extracted by mini-css-extract-plugin
export default {"commonCustomtable":"table_commonCustomtable__S7eVb"};